import { render, staticRenderFns } from "./PriceListsView.vue?vue&type=template&id=ae4d7e06&"
import script from "./PriceListsView.vue?vue&type=script&lang=ts&"
export * from "./PriceListsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports